import React, { useState, useEffect } from "react";
import { Fade } from "react-reveal";
import "./ContactComponent.css";
import { contactPageData } from "../../portfolio.js";
import ContactForm from "./Contact_Form.jsx";
import Navigationbar from "../../components/header/Navigationbar.jsx";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";
import BlogsImg from "./BlogsImg";
import AddressImg from "./AddressImg";
import Drawer from "@material-ui/core/Drawer";
import IconButton from "@material-ui/core/IconButton";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { makeStyles } from "@material-ui/core/styles";
import WhatsAppCard from "../../../src/pages/contact/WhatsAppCard.jsx";

const useStyles = makeStyles((theme) => ({
  drawerPaper: {
    width: "500px",
    height: "700px",
    position: "fixed",
    top: "13%",
    left: "74%",
    bottom: "13%",
    transform: "translate(-50%, -50%)",
    [theme.breakpoints.down(1300)]: { width: "80%", height: "65%", left: "62%", top: "15%" },
    [theme.breakpoints.down(1024)]: { width: "80%", height: "65%", left: "50%", top: "15%" },
    [theme.breakpoints.down(768)]: { width: "100%", height: "65%", left: "35%", top: "15%" },
    [theme.breakpoints.down(500)]: { width: "100%", height: "60%", left: "0%", top: "15%" },
  },
}));

const ContactData = contactPageData.contactSection;
const blogSection = contactPageData.blogSection;
const addressSection = contactPageData.addressSection;

const Contact = (props) => {
  const { theme, onToggle } = props;
  const [drawerOpen, setDrawerOpen] = useState(false);
  const classes = useStyles();
  
  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };
  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="contact-main">
      <Navigationbar theme={theme} />
      <div className="basic-contact">
        <Fade bottom duration={1000} distance="40px">
          <div className="contact-heading-div">
            <div className="contact-heading-text-div">
              <h1 className="contact-heading-text" style={{ color: theme.text }}>GET IN TOUCH</h1>
              <p className="contact-header-detail-text subTitle" style={{ color: theme.secondaryText }}>
                {ContactData["description"]}
              </p>
              <SocialMedia theme={theme} />
            </div>
          </div>
        </Fade>
        <Fade bottom duration={1000} distance="40px">
          <div className="blog-heading-div">
            <div className="blog-heading-text-div">
              <h1 className="blog-heading-text" style={{ color: theme.text }}>
                {blogSection["title"]}
              </h1>
              <div><ContactForm theme={theme} /></div>
            </div>
            <div className="blog-heading-img-div"><BlogsImg theme={theme} /></div>
          </div>
        </Fade>
        <Fade bottom duration={1000} distance="40px">
          <div className="address-heading-div">
            <div className="contact-heading-img-div"><AddressImg theme={theme} /></div>
            <div className="address-heading-text-div">
              <h1 className="address-heading-text" style={{ color: theme.text }}>
                {addressSection["title"]}
              </h1>
              <p className="contact-header-detail-text subTitle" style={{ color: theme.secondaryText }}>
                {addressSection["subtitle"]}
              </p>
              <div className="address-btn-div">
                <Button text="Visit on Google Maps" newTab={true} theme={theme} onClick={handleDrawerOpen} />
                <Drawer anchor="right" open={drawerOpen} onClose={handleDrawerClose} classes={{ paper: classes.drawerPaper }}>
                  <div>
                    <IconButton onClick={handleDrawerClose}><ChevronRightIcon /></IconButton>
                    <div className="mapouter">
                      <div className="gmap_canvas">
                        <iframe
                          width={450}
                          height={350}
                          src="https://maps.google.com/maps?q=Gopinath+Saha+Super+Market++Serampore+Pin+Code+-+712201&t=&z=17&ie=UTF8&iwloc=&output=embed"
                          frameBorder={0}
                          scrolling="no"
                          marginHeight={0}
                          marginWidth={0}
                        />
                      </div>
                    </div>
                  </div>
                </Drawer>
              </div>
            </div>
          </div>
        </Fade>
      </div>
      <Footer theme={theme} onToggle={onToggle} />
      <TopButton theme={theme} />
      <WhatsAppCard/>
    </div>
  );
};

export default Contact;
